/** Single source of truth for the product's name and identity (F21). Rename here only. */
export const BRAND = {
  name: 'Marrow',
  tagline: 'The body, explained for the curious.',
  fullTitle: 'Marrow — a 3D body atlas for the curious',
  shortDescription:
    'Rotate the body, peel it by system, and click any part for a plain-English explanation and one fact worth repeating at dinner. Free, no account.',
  longDescription:
    'Marrow is a free, in-browser 3D anatomy atlas written for curious people, not exam candidates. Every part of the body has a short card: what it does, one surprising fact, and why it matters to you.',
  themeColor: '#14323A',
  backgroundColor: '#FBF8F2',
  /** Public site origin; overridden at build time by VITE_SITE_URL. */
  siteUrl: 'https://marrow-atlas.netlify.app',
  /** Where readers report factual errors (F04/F08). */
  correctionsUrl: 'https://github.com/akhanrepo/anatomy-atlas-marouba/issues/new?labels=correction&title=Correction%3A%20',
  /** Short attribution line for share pages, exports and the footer (F09). */
  attribution: '3D models: Z-Anatomy & BodyParts3D (CC BY-SA 4.0 / 2.1 JP)',
} as const;

export type Brand = typeof BRAND;
